import { render, staticRenderFns } from "./StreamTabSlide.vue?vue&type=template&id=b21adc8e&scoped=true&"
import script from "./StreamTabSlide.vue?vue&type=script&lang=js&"
export * from "./StreamTabSlide.vue?vue&type=script&lang=js&"
import style0 from "./StreamTabSlide.vue?vue&type=style&index=0&id=b21adc8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21adc8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VImg,VRow,VTextField})
